import { get } from "lodash";
import { useMemo, useState } from "react";
import { Modal } from "components/modal";
import Pagination from "components/pagination";
import { generateUUID } from "utills/helpers";

export interface MultiMoveErrorType {
  field: string;
  message: string;
  registered_product_id: string;
  error: string;
}

interface PagingType {
  total_item: number;
  total_page: number;
  current_page: number;
}

interface PropType {
  data: MultiMoveErrorType[];
  open: boolean;
  handleClose: () => void;
}

const MultiMoveErrorModal = (props: PropType) => {
  const { data, open, handleClose } = props;

  const PAGE_SIZE = 5;

  const [page, setPage] = useState<number>(1);

  // Paginated invalid import data
  const PAGINATED_DATA = useMemo(() => {
    if (!data) return [];

    const start = (page - 1) * PAGE_SIZE;
    const end = start + PAGE_SIZE;

    return data?.slice(start, end);
  }, [data, page]);

  // Invalid import paging data
  const invalidPaging: PagingType = useMemo(() => {
    return {
      total_item: data?.length || 0,
      total_page: Math.ceil((data?.length || 0) / PAGE_SIZE),
      current_page: page,
    };
  }, [data, page]);

  const handlePageChange = (value: number) => {
    setPage(value);
  };

  const handleCloseModel = () => {
    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleCloseModel}
      title={`Multiple Move Attendants Error`}
      closeOnClickBackdrop={false}
    >
      <div className="p-5 flex flex-col gap-5">
        <div className="w-full max-h-[300px] overflow-y-auto">
          <table className="mb-6 w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
            <thead>
              <tr>
                <th scope="col" className="th">
                  Field
                </th>

                <th scope="col" className="th">
                  Registered Product ID
                </th>

                <th scope="col" className="th">
                  Message
                </th>

                <th scope="col" className="th">
                  Error
                </th>
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-200 bg-white">
              {PAGINATED_DATA?.map((item: MultiMoveErrorType) => {
                return (
                  <tr key={generateUUID()}>
                    <td className="td min-w-[200px]">
                      <span>{get(item, "field", "")}</span>
                    </td>

                    <td className="td min-w-[200px]">
                      <span>{get(item, "registered_product_id", "")}</span>
                    </td>

                    <td className="td min-w-[200px]">
                      <span>{get(item, "message", "")}</span>
                    </td>

                    <td className="td min-w-[200px]">
                      <span>{get(item, "error", "")}</span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <Pagination
          currentPage={get(invalidPaging, "current_page", 1)}
          totalPage={get(invalidPaging, "total_page", 0)}
          total={{
            totalItems: get(PAGINATED_DATA, "length", 0),
            total: get(invalidPaging, "total_item", 0),
          }}
          onChange={handlePageChange}
        />
      </div>
    </Modal>
  );
};

export default MultiMoveErrorModal;
